import { FunctionComponent, useCallback, useEffect, useState } from "react";
import SchoolAdminLogin from "./components/SchoolAdminLogin";
import "./AdminLoginPage.scss";
import { useLocation, useNavigate } from "react-router-dom";
import StudentSignup from "./components/StudentSignup";
import StudentVerifyClassCode from "./components/StudentVerifyClassCode";
import StudentForgotPassword from "./components/StudentForgotPassword";
import images from "../../assets/images";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { logout } from "../../redux/slices/authSlice";
import { CLASSROOM_S3_PATH, PTA_SIDE_IMAGE_NAME, TEACHER_LOGIN_BOTTOM_IMAGE_NAME } from "../../utils/constants";

const AdminLoginPage: FunctionComponent = () => {
  const baseURL = process.env.REACT_APP_FRONTEND_URL;
  const [signupSuccess, setSignupSuccess] = useState<boolean>(false);
  const {backArrow} = images;
  const location = useLocation();
  let title='';
  let loginPage = '';
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isKaton = useAppSelector((state) => state.auth.isKaton);
  const participantCode = useAppSelector((state) => state.auth.participantCode);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const bannerImage = () => {
    if (location.pathname?.includes("/admin-login")) {
      title = "Log in as School Admin";
      loginPage = "adminLogin";
      return baseURL + CLASSROOM_S3_PATH + "images/LampImage.jpg";
    } else if (location.pathname?.includes("/teacher-login")) {
      title = "Log in as a Teacher";
      loginPage = "teacherLogin";
      return baseURL + CLASSROOM_S3_PATH + TEACHER_LOGIN_BOTTOM_IMAGE_NAME;
    } else if (location.pathname?.includes("/student-signup")) {
      title = "Sign Up";
      loginPage = "studentSignup";
      return baseURL + CLASSROOM_S3_PATH + TEACHER_LOGIN_BOTTOM_IMAGE_NAME;
    } else if (location.pathname?.includes("/student-login")) {
      title = "Log In";
      loginPage = "studentLogin";
      return baseURL + CLASSROOM_S3_PATH + TEACHER_LOGIN_BOTTOM_IMAGE_NAME;
    } else if (location.pathname?.includes("/student-verifyCode")) {
      title = "Join with Passcode";
      loginPage = "studentVerifyCode";
      return baseURL + CLASSROOM_S3_PATH + TEACHER_LOGIN_BOTTOM_IMAGE_NAME;
    } else if (location.pathname?.includes("/pta-signup")) {
      title = "Sign Up";
      loginPage = "ptaSignup";
      return baseURL + CLASSROOM_S3_PATH + PTA_SIDE_IMAGE_NAME;
    } else if (location.pathname?.includes("/pta-verifyCode")) {
      title = "Join with Passcode";
      loginPage = "ptaVerifyCode";
      return baseURL + CLASSROOM_S3_PATH + PTA_SIDE_IMAGE_NAME;
    } else if (location.pathname?.includes("/pta-login")) {
      title = "Log In";
      loginPage = "ptaLogin";
      return baseURL + CLASSROOM_S3_PATH + PTA_SIDE_IMAGE_NAME;
    } else if (location.pathname?.includes("/student-forgot-password")) {
      loginPage = "forgotPassword";
      return baseURL + CLASSROOM_S3_PATH + TEACHER_LOGIN_BOTTOM_IMAGE_NAME;
    } else if (location.pathname?.includes("/facilitator-login")) {
      title = "Facilitator Login";
      loginPage = "facilitatorLogin";
      return "";
    } else if (location.pathname?.includes("/participant-login")) {
      title = "Participant Login";
      loginPage = "participantLogin";
      return "";
    } else if (location?.pathname?.includes("/virtual-school/virtual-student-signup")) {
      title = "Sign Up";
      loginPage = "virtualStudentSignup";
      return "";
    } else if (location?.pathname?.includes("/virtual-school/virtual-student-login")) {
      title = "Log In";
      loginPage = "virtualStudentLogin";
      return "";
    } else if (location?.pathname?.includes("/virtual-school/virtual-teacher-login")) {
      title = "Log in as a Teacher";
      loginPage = "virtualTeacherLogin";
      return "";
    } else if (location.pathname?.includes("/virtual-school/virtual-student-forgot-password")) {
      loginPage = "VirtualForgotPassword";
      return "";
    } 

  };
  const image = bannerImage();

  // navigate to landing page while click header logo
  const onHeaderLogoImageClick = useCallback(() => {
    const component = isKaton === "facilitator" 
                    ? "/facilitator-login?isKaton=facilitator" 
                    : isKaton === "participant" 
                      ? `/participant-login${location?.search 
                        ? location?.search 
                        : `?isKaton=participant&code=${participantCode}`}` 
                      : "/";
    navigate(component);
    dispatch(logout());
  }, [isKaton]);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
  return (
    <div className="adminSignInPageOuterCtn">
      {windowWidth <= 768 && <div className="headerBackBtn" onClick={onHeaderLogoImageClick} >
        <img className="headerBackIcon" src={backArrow} alt="backe=arrow" />
        <span className="headerBackText" >Back</span>
      </div>}
    <div className="adminSignInPage">
      {(loginPage !== 'facilitatorLogin' && 
        loginPage !== 'participantLogin' && 
        loginPage !== 'virtualStudentSignup' && 
        loginPage !== 'virtualStudentLogin' && 
        loginPage !== 'virtualTeacherLogin' && loginPage !== 'VirtualForgotPassword') && 
        <div 
            className={`adminSignInLeftImageContainer ${(loginPage === "ptaVerifyCode" || loginPage === "ptaSignup" || loginPage === "ptaLogin") ? 'adminSignInLeftImageContainerPta' : ''}`}
>
          {/* Admin Login Page Lamp Image */}
          <img className="adminSignINLeftImageLamp" alt="AdminSignInImage" src={image} data-testid="adminLeftSingInImage" />
        </div>
      }
      {
        (loginPage === 'studentSignup' || loginPage === 'virtualStudentSignup') && !signupSuccess
        ?
            <StudentSignup title = {title} loginpage = {loginPage} setSignupSuccess={setSignupSuccess}/>
        : 
            loginPage === 'studentVerifyCode'
        ? 
            <StudentVerifyClassCode loginType={"student"}/>
        :
            (loginPage === 'ptaVerifyCode') 
        ?
            <StudentVerifyClassCode loginType={"pta"}/>
        :
            (loginPage === 'ptaSignup')
        ?
            <StudentSignup title = {title} loginpage = {loginPage} setSignupSuccess={setSignupSuccess}/>
        :
            (loginPage === 'forgotPassword' || loginPage === 'VirtualForgotPassword')
        ?  
            <StudentForgotPassword/>
        :
            <SchoolAdminLogin title={title} loginpage={loginPage} setSignupSuccess={setSignupSuccess}/>
      }
    </div>
    </div>
  );
};

export default AdminLoginPage;
